import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import { Match, Switch } from "solid-js";
import {
  TOV_SECTION_KEY,
  TOV_SECTION_KEYS,
  type TovSectionKey,
} from "../../enums/tov";
import { ActivityCards } from "./ActivityCards";
import { ChannelCards } from "./ChannelCards";
import type { CardEditProps } from "./EditForms";
import { SourcesPanel } from "./SourcesPanel";
import { StrategyCards } from "./StrategyCards";
import { VoiceCards } from "./VoiceCards";

const TAB_LABELS: Record<TovSectionKey, string> = {
  voice: "Voice",
  strategy: "Strategy",
  channels: "Channels",
  sources: "Sources",
  activity: "Activity",
};
const TABS = TOV_SECTION_KEYS.map((key) => ({ key, label: TAB_LABELS[key] }));

// In-page section tabs over one Version. The Sources tab drives ingestion
// (upload + cascade + parsed view); Evidence/Chat surfaces slot in later.
// The active tab is controlled by the parent so external actions (e.g. the
// header "Upload document" button) can switch to the Sources tab.
export function SectionTabs(props: {
  clientId: string;
  version: TovVersionResponse;
  edit: CardEditProps;
  active: TovSectionKey;
  onActiveChange: (key: TovSectionKey) => void;
}) {
  return (
    <>
      <div class="tov-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            type="button"
            role="tab"
            aria-selected={props.active === tab.key}
            class={`tov-tab ${props.active === tab.key ? "is-active" : ""}`}
            onClick={() => props.onActiveChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <Switch>
        <Match when={props.active === TOV_SECTION_KEY.VOICE}>
          <VoiceCards version={props.version} edit={props.edit} />
        </Match>
        <Match when={props.active === TOV_SECTION_KEY.STRATEGY}>
          <StrategyCards version={props.version} edit={props.edit} />
        </Match>
        <Match when={props.active === TOV_SECTION_KEY.CHANNELS}>
          <ChannelCards channels={props.version.channels} edit={props.edit} />
        </Match>
        <Match when={props.active === TOV_SECTION_KEY.SOURCES}>
          <SourcesPanel
            clientId={props.clientId}
            versionId={props.version.id}
          />
        </Match>
        <Match when={props.active === TOV_SECTION_KEY.ACTIVITY}>
          <ActivityCards version={props.version} />
        </Match>
      </Switch>
    </>
  );
}
